import { useMemo, useState } from 'react'
import type { EliteOnboardingStatusResponse } from '../../../types/misc.types'
import type { EliteLandingPlan } from '../../new-elite-landing/planTypes'
import { useSyncEliteLandingPlanFromEligiblePlans } from '../../new-elite-landing/hooks/useSyncEliteLandingPlanFromEligiblePlans'
import {
  buildElitePlansAdvisorySelectionViewModel
} from '../elitePlansAdvisorySelection'
import type { ElitePlansAdvisorySelection } from '../types/advisory.types'

export type { ElitePlansAdvisorySelection } from '../types/advisory.types'

export function useElitePlansAdvisorySelection(
  status: EliteOnboardingStatusResponse | undefined,
  enabled: boolean
): ElitePlansAdvisorySelection | null {
  const [selectedTenure, setSelectedTenure] = useState<EliteLandingPlan>('yearly')
  const eligiblePlans = status?.eligiblePlans ?? []

  useSyncEliteLandingPlanFromEligiblePlans(
    enabled ? eligiblePlans : [],
    setSelectedTenure,
    enabled ? status?.selectedPlanDetails : undefined
  )

  return useMemo(() => {
    if (!enabled || !status) {
      return null
    }

    return {
      ...buildElitePlansAdvisorySelectionViewModel(status, selectedTenure),
      selectedTenure,
      setSelectedTenure
    }
  }, [enabled, selectedTenure, status])
}
